const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const API_URL = '/service';

export const getInstitutionServices = async (institutionId) => {
    try {
        const response = await fetch(`${BASE_URL}${API_URL}/institution/${institutionId}`);

        if (!response.ok) {
            console.error('فشل في تحميل الخدمات:', response.status);
            throw new Error('حدث خطأ أثناء تحميل الخدمات');
        }

        return await response.json();
    } catch (error) {
        throw error.message || 'حدث خطأ أثناء تحميل الخدمات';
    }
};

export const editService = async (token, id, data) => {
    try {
        const response = await fetch(`${BASE_URL}${API_URL}/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify(data),
        });

        if (!response.ok) {
            console.error('فشل في تعديل الخدمة:', response.status);
            throw new Error('حدث خطأ أثناء تعديل بيانات الخدمة');
        }

        return await response.json();
    } catch (error) {
        throw error.message || 'حدث خطأ أثناء تعديل بيانات الخدمة';
    }
};

export const deleteService = async (token, id) => {
    try {
        const response = await fetch(`${BASE_URL}${API_URL}/${id}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            console.error('فشل في حذف الخدمة:', response.status);
            throw new Error('حدث خطأ أثناء حذف الخدمة');
        }

        return await response.json();
    } catch (error) {
        throw error.message || 'حدث خطأ أثناء حذف الخدمة';
    }
};

export const addNewService = async (token, service) => {
    try {
        const response = await fetch(`${BASE_URL}${API_URL}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(service),
        });
        if (!response.ok) {
            throw new Error(response.message);
        }
        return await response.json();
    } catch (error) {
        throw error('حدث خطأ اثناء حجز الموعد, يرجى المحاولة مرة اخرى');
    }
}

export const getBranchServices = async (branchId) => {
    try {
        const response = await fetch(`${BASE_URL}${API_URL}/branch/${branchId}`);

        if (!response.ok) {
            console.error('فشل في تحميل الخدمات:', response.status);
            throw new Error('حدث خطأ أثناء تحميل الخدمات');
        }

        return await response.json();
    } catch (error) {
        throw error.message || 'حدث خطأ أثناء تحميل الخدمات';
    }
};
